import React from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';
import { RightOutlined } from '@ant-design/icons';

import RouterLink from './RouterLink';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';

export type ButtonProps = Omit<AntButtonProps, 'children'> & {
  to?: string;
  comcode: string;
  custom?:any;
};

const NextButton = ({ comcode,custom, ...otherProps }: ButtonProps) => {
  const { isHidden, label, style } = useComponentConfiguration(comcode);

  if (isHidden) {
    return null;
  }

  const props = {
    ...otherProps,
    children: label,
    style,
  };

  if (props.to) {
    return <RouterLink component={AntButton} {...props} />;
  } else {
    return (
      <AntButton
        {...props}
        icon={<RightOutlined />}
        type="primary"
        style={{ width: custom?.width??'20%', height: custom?.height??40 }}
      />
    );
  }
};

export default NextButton;
